<template>
  <div class="container-custom">
    <!-- Breadscrumbs -->
    <Breadscrumbs
      :links="[{ name: 'EDMSCenter', to: { path: '/edms-center' } }]"
    ></Breadscrumbs>
    <!-- page-actions -->
    <div class="page-actions">
      <h2>eDM Center</h2>
      <v-spacer></v-spacer>
      <button class="btn btn-primary" @click="toEDMSCreate">
        <v-icon class="mr-2 white--text">add</v-icon>
        <span>新增EDM</span>
      </button>
    </div>
    <!-- block -->
    <div class="block mb-5">
      <EDMSCenterTable></EDMSCenterTable>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import Breadscrumbs from '@/components/Breadscrumbs.vue';
import EDMSCenterTable from '@/views/E-9__Edms/c/EDMSCenterTable.vue';

export default {
  components: {
    Breadscrumbs,
    EDMSCenterTable,
  },
  created() {
    this.clear();
    this.getEDMSList();
  },
  methods: {
    ...mapActions('edms', {
      getEDMSList: 'find',
      clear: 'clear',
    }),
    toEDMSCreate() {
      this.$router.push('/edms-center/create');
    },
  },
};
</script>

<style></style>
